import { some } from "lodash-es";

import { NgrxUtilsState } from "../model";

import { CONTEXT_REGEX } from "./fetch-status.const";
import { FetchStatusType } from "./fetch-status.model";

export namespace FetchStatusSelector {
	export const isBusy =
		(actionType: string) =>
		(state: NgrxUtilsState): boolean =>
			isStatusOrBusy(actionType)(state);

	export const isStatus =
		(actionType: string, fetchStatusPredicate = FetchStatusType.Loading) =>
		(state: NgrxUtilsState): boolean =>
			isStatusOrBusy(actionType, fetchStatusPredicate)(state);

	const isStatusOrBusy =
		(actionType: string, fetchStatusPredicate = FetchStatusType.Loading) =>
		(state: NgrxUtilsState): boolean => {
			const contextRegexResult = CONTEXT_REGEX.exec(actionType);

			if (!contextRegexResult) {
				return false;
			}
			const context = contextRegexResult[0];
			const contextMap = state.fetchStatus[context];

			if (!contextMap) {
				return false;
			}

			// if a specific action is asked (e.g.: "[Hero] Get All")
			if (actionType !== context) {
				return contextMap[actionType] === fetchStatusPredicate;
			}

			return some(contextMap, (status) => status === fetchStatusPredicate);
		};
}
